import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./ListFilterButton.scss";
import { CommonEnums } from "../../../enums/common.enums";
import { commonAction } from "../../../redux/features/commonSlice";
import FilterIcon from "../../../components/icons/FilterIcon";

const ListFilterButton = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const onClickFilter = () => {
    dispatch(commonAction?.setHomePageFilter());
  };

  const checkFilter = () => {
    let filter_check = false;
    // user filter
    let role = searchParams.get(CommonEnums.queryParams?.role) || "";

    // agency filter
    let agent_id = searchParams.get(CommonEnums.queryParams?.agent_id) || "";
    let agent_name =
      searchParams.get(CommonEnums?.queryParams?.agent_name) || "";
    let registration_status =
      searchParams.get(CommonEnums.queryParams?.registration_status) || "";
    let cities_id =
      searchParams.get(CommonEnums.queryParams?.agentFilter?.cities) || "";

    // agent filter
    let agency_id = searchParams.get(CommonEnums.queryParams?.agency_id) || "";

    // template types filter
    let subscription_type =
      searchParams.get(CommonEnums.queryParams?.subscription_type) || "";
    let post_type = searchParams.get(CommonEnums.queryParams?.post_type) || "";
    let stage_type =
      searchParams.get(CommonEnums.queryParams?.stage_type) || "";

    let listing_type =
      searchParams.get(CommonEnums.queryParams?.listing_type) || "";

    // template filter
    let subscription_plan =
      searchParams.get(CommonEnums.queryParams?.role) || "";
    let template_type = searchParams.get(CommonEnums.queryParams?.role) || "";

    // common
    let start_date = searchParams.get(CommonEnums.queryParams.start_date) || "";
    let end_date = searchParams.get(CommonEnums.queryParams.end_date) || "";
    let status = searchParams.get(CommonEnums?.queryParams?.status) || "";

    let check_value =
      role ||
      agent_id ||
      agent_name ||
      registration_status ||
      cities_id ||
      agency_id ||
      subscription_type ||
      post_type ||
      stage_type ||
      subscription_plan ||
      listing_type ||
      template_type ||
      start_date ||
      end_date ||
      status;

    if (check_value) {
      filter_check = true;
    } else {
      filter_check = false;
    }

    return filter_check;
  };

  return (
    <button
      className={`list-filter-button ${
        checkFilter() ? "list-filter-button-active" : ""
      } `}
      onClick={onClickFilter}
    >
      <div className="filter-icon">
        <FilterIcon />
      </div>
      <p> Filters</p>
    </button>
  );
};

export default ListFilterButton;
